/* 
 - TODO: Explanation
*/

import { DatabaseTable, returnID } from "../BaseTable";
import { types } from "../../helpers/Util";
import store from "../../store/Store";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import {
  compareInteractionNodesByOrdinality,
  stateDeepCopy,
} from "../../helpers/DataUpdateHelper";
import { postgrest_operators, queryTable, runDatabaseFunction } from "../../helpers/HttpHelper";

class InteractionNodeRaw extends DatabaseTable {
  id: number;
  set_interaction_id: number;
  parent_interaction_id: number;
  ordinal: number;
  child_interaction_id: number;
  condition_id: number | null;
  modified: Date;

  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["set_interaction_id", [types.number]],
    ["parent_interaction_id", [types.number]],
    ["ordinal", [types.number]],
    ["child_interaction_id", [types.number]],
    ["condition_id", [types.number, types.null]],
    ["modified", [types.date, types.string]],
  ]);
  static readonly tableName = "InteractionNode";

  constructor(
    id = -1,
    set_interaction_id = -1,
    parent_interaction_id = -1,
    ordinal = -1,
    child_interaction_id = -1,
    condition_id = null,
    modified = new Date(),
  ) {
    super();
    this.id = returnID(id);
    this.set_interaction_id = set_interaction_id;
    this.parent_interaction_id = parent_interaction_id;
    this.ordinal = ordinal;
    this.child_interaction_id = child_interaction_id;
    this.condition_id = condition_id;
    this.modified = modified;
  }
}

class InteractionNode extends InteractionNodeRaw {
  constructor(...args: any[]) {
    super(...args);
  }

  async onDelete() {
    InteractionNode.updateInteractionNodeOrdinalityByParentAndNode(
      this.id,
      this.parent_interaction_id,
      this.ordinal,
      null,
      true,
    );
  }

  public static updateInteractionNodeOrdinalityByParentAndNode(
    nodeid: number,
    parentid: number,
    oldOrdinal: number,
    newOrdinal: number | null,
    deleteNode: boolean | null | undefined,
  ) {
      store.dispatch(interactionTreeSliceActions.updateInteractionNodeOrdinalityByParentAndNode({
          nodeid:nodeid,
          parentid :parentid,
          oldOrdinal : oldOrdinal,
          newOrdinal :newOrdinal,
          deleteNode : deleteNode
      }))
      return;
  }

  public static findFromNavHistory = async (
    thisSet: number,
    thisParent: number | null = null,
    thisNodeID: number | null = null,
  ) => {
    const navHistory = store.getState().nav.navHistory
    if (thisParent) {
      thisSet = thisParent;
    }

    let thisNode: InteractionNode | null = null;
    // init empty state
    if (navHistory.length > 1) {
      const thisNavHistory = navHistory[navHistory.length - 2];
      if (
        thisNavHistory.state.interaction_nodes &&
        thisNavHistory.state.interaction_nodes.length > 0
      ) {
        let directAncestorNodeIndex: number;
        if (thisNodeID) {
          directAncestorNodeIndex =
            thisNavHistory.state.interaction_nodes.findIndex(
              (interaction_node: InteractionNode) => {
                return interaction_node.id === thisNodeID;
              },
            );
        } else {
          directAncestorNodeIndex =
            thisNavHistory.state.interaction_nodes.findIndex(
              (interaction_node: InteractionNode) => {
                return interaction_node.child_interaction_id  === thisSet;
              },
            );
        }
        thisNode =
          thisNavHistory.state.interaction_nodes[directAncestorNodeIndex];
      }
    }
    if(!thisNode && thisNodeID){
      const thisNodeArray = await InteractionNode.findByID(thisNodeID)
      thisNode = thisNodeArray[0];
    }
    return thisNode;
  };

  public static async findByID(interaction_node_id:number){
    const response = await queryTable('interaction_node', [
      {
        column: "id",
        operator: postgrest_operators.eq,
        value: interaction_node_id.toString(),
      },
    ]);
    const responseJSON = await response.json();
    return responseJSON;
  }

  public static async updateInteractionSetID(
    parentid : number, 
    currentsetid : number, 
    childid : number, 
    newsetid : number
  ) {
    const params = {
      parent_id: parentid,
      current_set_id: currentsetid,
      child_id: childid,
      new_set_id: newsetid
    };

    const dbFunc = "update_interaction_set_id";
    try {
      await runDatabaseFunction(dbFunc, params)
      window.location.reload();
      // TODO - NEED TO UPDATE THE NODES IN REDUX AS WELL, IN A SIMILAR WAY
    } catch (err: any) {
      console.error("Error with update_interaction_set_id: " + err);
    }
      return;
  }

  public copy(){
    let params = {};
    const dbFunc = "fn_copy_interaction";
    params = {
      interactionid: this.child_interaction_id,
      nodeid: this.id,
      copied_ids: {},
      setid: this.set_interaction_id,
      parentid: this.parent_interaction_id,
    };

    try {
      runDatabaseFunction(dbFunc, params).then(async (data: any) => {
        data = await data.text();
        data = JSON.parse(data);
        console.log(data)
 
      });
    } catch (err: any) {
      console.error("Error with copying interaction: " + err);
    }
  }

}

export default InteractionNode;


export interface CopyProps {
  "interval": any;
  "condition": any;
  "interaction": any;
  "interval_set": any;
  "communication": any;
  "interaction_node": any;
  "communication_set": any;
  "interaction_node_interval": any;
  "interaction_instance_property": any;
}